import { useEffect, useState } from "react";

export const useElementScrollPositions = (htmlelement: React.RefObject<HTMLElement>) => {
  const [scrollPosition, setScrollPosition] = useState({ posX: 0, posY: 0 });

  useEffect(() => {
    function updatePosition() {
      if (htmlelement?.current) {
        setScrollPosition({
          posX: htmlelement.current.scrollLeft,
          posY: htmlelement.current.scrollTop,
        });
      }
    }

    if (htmlelement?.current) {
      htmlelement.current.addEventListener("scroll", updatePosition);
      updatePosition();
    }

    const savedElement = htmlelement?.current;

    return () => {
      if (savedElement) {
        savedElement.removeEventListener("scroll", updatePosition);
      }
    };
  }, [htmlelement]);

  return scrollPosition;
};
